<ub-button-list>
  <ng-container>
    @if (eligibilityId !== null) {
      <button mat-stroked-button color="accent" type="button" (click)="onEdit(eligibilityId)" i18n>Edit this rule</button>
      <button mat-stroked-button color="accent" type="button" (click)="onDuplicate(eligibilityId)" i18n>Duplicate this rule</button>
    }
  </ng-container>
  <button mat-flat-button color="accent" type="button" (click)="onCreate()" i18n>Create new rule</button>
</ub-button-list>
